













































































































































































































































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import AuthModule from "@/store/auth";
import { Category, Material, MaterialGroup, MaterialGroupList, News } from "@/api/lab-base-api-client";
import NewsApi from "@/services/News";
import CategoriesApi from "@/services/CategoriesApi";
import MaterialGroupApi from "@/services/MaterialGroups";
import dayjs from "dayjs";
import { ValidationObserver } from "vee-validate";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MNewsList extends CheckAdminLogin {
  // tableのheader設定配列
  private headers = [
    {
      text: "date",
      align: "start",
      value: "createdAt",
    },
    {
      text: "title",
      value: "title",
    },
    { text: "", value: "actions" },
  ];

  // tableのデータ配列
  private newsList: News[] = [];

  // selectのcategoryデータ配列
  private categories: Category[] = [];

  // selectのmaterialGroupデータ配列
  private materialGroups: MaterialGroupList[] = [];

  // selectのmaterialデータ配列
  private materials: Material[] = [];

  /**
   * 選択した教材
   */
  private category: Category | null = null;

  private materialGroup: MaterialGroup | null = null;

  private material = "";

  // 削除・編集の対象のuuid
  private targetNewsUuid = "";

  private isNewDialog = false;

  private defaultCreateItems = { title: "", content: "", userUuid: "" };

  private createItems = { title: "", content: "", userUuid: "" };

  private isEditDialog = false;

  private editItems = { title: "", content: "", userUuid: "" };

  private isDeleteDialog = false;

  // 削除確認チェックボックス
  private checkbox = false;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private get check() {
    return this.checkbox;
  }

  // ページ読み込み時に事項
  private async mounted() {
    await this.fetch();
  }

  // news一覧の取得
  private async fetch() {
    const NewsRes = await NewsApi.instance.getNews();
    if (!NewsRes.data.data) {
      return;
    }
    this.newsList = NewsRes.data.data.items;

    this.newsList.forEach((item: News, index: number) => {
      this.newsList[index].createdAt = String(dayjs(item.createdAt).format("YYYY/MM/DD"));
    });
  }

  // 「New」clickで実行
  private async onNewItem() {
    this.isNewDialog = true;

    if (!this.me) {
      return;
    }
    this.createItems.userUuid = this.me.uuid;
    await this.setCategories();
  }

  // categoryを取得しセット
  private async setCategories() {
    const CategoriesRes = await CategoriesApi.instance.getCategories();
    if (!CategoriesRes.data.data.categories) {
      return;
    }
    this.categories = CategoriesRes.data.data.categories;
  }

  // categoryを選択した時実行、materialGroupを取得しセット
  private async setContents(category: Category) {
    this.materialGroups = [];
    this.materials = [];
    this.materialGroup = null;
    this.material = "";

    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroup();
    const materialGroups = materialGroupsRes.data.data.items.filter(
      (materialGroup: { categories: {} }) => materialGroup.categories
    );

    materialGroups.forEach((materialGroup: MaterialGroupList) => {
      // カテゴリ-の数分回す
      for (let i = 0; i < materialGroup.categories.length; i += 1) {
        // カテゴリーidとqueryのidが同一かつmaterialsが一つ以上あれば
        if (materialGroup.categories[i].id === category.id) {
          this.materialGroups.push(materialGroup);
        }
      }
    });
  }

  // materialGroupを選択した時実行、materialを取得しセット
  private async setMaterials(materialGroup: { uuid: string }) {
    this.material = "";
    const materialGroupRes = await MaterialGroupApi.instance.getMaterialGroupByUuid(materialGroup.uuid);
    if (materialGroupRes.data.data.materialGroup.materials) {
      this.materials = materialGroupRes.data.data.materialGroup.materials.filter(
        (material: { deleted: boolean }) => !material.deleted
      );
    }
  }

  // リンクセット
  private setLink() {
    if (!this.category) {
      return;
    }
    let link = "";

    const editText = this.$refs.linkText as Vue;
    if (editText) {
      editText.$el.classList.add("flash");
      setTimeout(() => {
        editText.$el.classList.remove("flash");
      }, 500);
    }
    if (this.material) {
      if (!this.materialGroup) {
        return;
      }
      // material
      link = `${window.location.origin}${
        this.$router.resolve({
          name: "UContent",
          params: { category: this.category.slug, content: this.materialGroup.name },
          query: { uuid: this.materialGroup.uuid, material: this.material },
        }).href
      }`;
    } else if (this.materialGroup) {
      // materialGroup
      link = `${window.location.origin}${
        this.$router.resolve({
          name: "UContent",
          params: { category: this.category.slug, content: this.materialGroup.name },
          query: { uuid: this.materialGroup.uuid, material: this.materials[0].uuid },
        }).href
      }`;
    } else if (this.category.id) {
      // category
      link = `${window.location.origin}${
        this.$router.resolve({
          name: "UContents",
          params: { category: this.category.slug },
          query: { id: String(this.category.id) },
        }).href
      }`;
    }
    if (!this.isEditDialog) {
      this.createItems.content = link;
    } else {
      this.editItems.content = link;
    }
  }

  // 登録ダイアログ「save」で実行、Newsを登録
  private async save() {
    try {
      const NewsRes = await NewsApi.instance.createNews(this.createItems);
      if (!NewsRes?.data?.data?.news) {
        return;
      }
      this.closeCreate();
      await this.fetch();
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // 登録ダイアログを閉じる
  private closeCreate() {
    this.isNewDialog = false;
    this.createItems = { ...this.defaultCreateItems };
    this.category = null;
    this.materialGroup = null;
    this.material = "";
    // バリデーションリセット
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }

  // 編集アイコンclickで実行
  private async onEditItem(news: News) {
    this.isEditDialog = true;

    this.targetNewsUuid = news.uuid;
    this.editItems.title = news.title;
    this.editItems.content = news.content;
    if (!this.me) {
      return;
    }
    await this.setCategories();
    this.editItems.userUuid = this.me.uuid;
  }

  // 編集ダイアログの「ok」クリックで実行
  private async saveEdit() {
    try {
      await NewsApi.instance.updateNewsByUuid(this.targetNewsUuid, this.editItems);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.closeEdit();
    this.fetch();
  }

  // 編集ダイアログを閉じる
  private closeEdit() {
    this.isEditDialog = false;
    this.category = null;
    this.materialGroup = null;
    this.material = "";
  }

  // 削除アイコンclickで実行
  private async onDeleteItem(newsUuid: string) {
    this.isDeleteDialog = true;
    this.targetNewsUuid = newsUuid;
  }

  // 削除ダイアログの「ok」クリックで実行
  private async deleteItemCfm() {
    try {
      await NewsApi.instance.deleteNewsByUuid(this.targetNewsUuid);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.closeDelete();
    await this.fetch();
  }

  // 削除ダイアログを閉じる
  private closeDelete() {
    this.isDeleteDialog = false;
    this.targetNewsUuid = "";
    this.checkbox = false;
  }
}
